module.exports = __webpack_public_path__ + "assets/img/activity-time-66df009a.png";